import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Avatar, IconButton, Menu, MenuItem,
  Tabs, Tab, Chip } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useBranding } from '../../contexts/BrandingContext';
import { viewerAPI } from '../../services/api';

export default function ViewerLayout() {
  var auth = useAuth();
  var branding = useBranding();
  var user = auth.user, logout = auth.logout;
  var navigate = useNavigate();
  var location = useLocation();
  var as = useState(null); var anchorEl = as[0]; var setAnchorEl = as[1];
  var ef = useState([]); var editFormIds = ef[0]; var setEditFormIds = ef[1];

  useEffect(function() {
    viewerAPI.context().then(function(r) {
      var data = r.data && r.data.data;
      if (data && data.edit_form_ids) {
        setEditFormIds(data.edit_form_ids);
      }
    }).catch(function(e) {});
  }, []);

  var hasEditAccess = editFormIds.length > 0 || (user && user.role === 'admin');

  var tab = location.pathname.indexOf('/viewer/editor') === 0 ? 'editor'
    : location.pathname.indexOf('/viewer/registrations') === 0 ? 'registrations'
    : location.pathname.indexOf('/viewer/applications') === 0 ? 'applications' : 'dashboards';
  var E = React.createElement;

  return E(Box, {sx:{minHeight:'100vh', bgcolor:'background.default'}},
    E(AppBar, {position:'static', sx:{bgcolor:'primary.main'}},
      E(Toolbar, null,
        E(Typography, {variant:'h6', sx:{flexGrow:1, cursor:'pointer'},
          onClick:function(){ navigate('/viewer'); }}, branding.portal_name + ' \u2014 Insights'),
        E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
          !hasEditAccess ? E(Chip, {label:'Read only', size:'small',
            sx:{bgcolor:'rgba(255,255,255,0.18)', color:'#fff'}}) : null,
          E(Typography, {variant:'body2'}, user && user.name),
          E(IconButton, {color:'inherit', onClick:function(e){ setAnchorEl(e.currentTarget); }},
            E(Avatar, {sx:{width:32, height:32, bgcolor:'secondary.main', fontSize:14}},
              user && user.name ? user.name.charAt(0).toUpperCase() : '?')),
          E(Menu, {anchorEl:anchorEl, open:Boolean(anchorEl), onClose:function(){ setAnchorEl(null); }},
            (user && user.role) === 'admin'
              ? E(MenuItem, {onClick:function(){ navigate('/admin'); setAnchorEl(null); }}, 'Admin panel')
              : null,
            E(MenuItem, {onClick:function(){ logout(); navigate('/login'); }},
              E(Logout, {sx:{mr:1, fontSize:18}}), 'Sign out'))))),

    E(Box, {sx:{bgcolor:'background.paper', borderBottom:1, borderColor:'divider'}},
      E(Box, {sx:{maxWidth:1200, mx:'auto', px:3}},
        E(Tabs, {value:tab, onChange:function(_, v){ navigate('/viewer/' + v); }},
          E(Tab, {value:'dashboards', label:'Dashboards'}),
          E(Tab, {value:'applications', label:'Applications'}),
          E(Tab, {value:'registrations', label:'Registrations'}),
          hasEditAccess ? E(Tab, {value:'editor', label:'Build forms'}) : null))),

    E(Box, {sx:{maxWidth:1200, mx:'auto', p:3}}, E(Outlet)));
}
